import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  isLoggedIn: false,
};

export const batchClassReducer = createReducer(initialState, {
  [types.BATCH_CLASS_RESPONSE](state, action) {
    return {
      ...state,
      timestamp: action.response.timestamp,
      data: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
